import * as actions from '../actions/caseTypes';
import * as ActionTypes from '../actions/index';
import xs from 'xstream';
import BASE_URL from './variables';


export function reqGetCaseTypes(sources) {

    //below the request$ describes to the HTTP Cycle driver what http request to make and the requests details
    const request$ = sources.ACTION
        .filter(action => action.type === ActionTypes.GET_CASE_TYPES)
        .map(action => ({
            url: BASE_URL + 'api/CaseTypes/CaseTypes',
            category: 'reqGetCaseTypes',
            method: 'GET',
            type: 'application/json',
            withCredentials: true
        }));

    let httpResponse$ = sources.HTTP
        .select('reqGetCaseTypes')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status === 200)
        .map(response => actions.receiveCaseTypes(JSON.parse(response.text)))

    return {
        ACTION: httpResponse$,
        HTTP: request$
    };
}

export function failedGetCaseTypesReq(sources) {
    let httpResponse$ = sources.HTTP
        .select('reqGetCaseTypes')
        .map((response) =>
            response.replaceError((err) => xs.of(err))
        )
        .flatten()
        .filter(response => response.status !==200)
        .map(response => actions.failedToGetCaseTypes(response))

    return {
        ACTION: httpResponse$
    };
}